import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import { useLocation, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ProductBasicInfo from "../../../../Components/product/store/productform";
import ProductImages from "../../../../Components/product/store/ProductImages";
import ProductNutrition from "../../../../Components/product/store/ProductNutrition";
import ProductOptions from "../../../../Components/product/store/ProductOptions";
import ProductPrices from "../../../../Components/product/store/productPrices";
import AddsOne from "../../../../Components/stores/storesStore/addsone";
import HeaderBar from "../../../../Components/UI/headerbar";
import LoadingSpinner from "../../../../Components/UI/spinner";
import { editProduct, showProducts } from "../../../../MyApi/product";
import { getCategories } from "../../../../MyApi/product/categories";
import { getStores } from "../../../../MyApi/stores";
import { PRODUCT_SECTION_CONFIG } from "../store/productconfig";
import Button from "../../../../Components/UI/buttonGlobal";
import { formatPrice } from "../../../../utils/formatPrice";
import i18next from "i18next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ProductAvailability from "../../../../Components/product/store/productAvability";
const EditProductPage = () => {
  const { id } = useParams();

  const lang = i18next.language;
  const [selectedLangCode, setSelectedLangCode] = useState(lang);
  const { data: showData, isLoading } = useQuery(
    ["showproduct", id, selectedLangCode],
    () => showProducts(id, selectedLangCode),
  );
  const [errors, setErrors] = useState({});
  const [section_id, setSectionId] = useState(null);
  const product = showData?.data?.product || {};
  const [section_type, setSectionType] = useState("regular_store");
  const config = PRODUCT_SECTION_CONFIG[section_type];
  const [addsOnsPayload, setAddsOnsPayload] = useState([]);
  console.log("config", config);
  const [images, setImages] = useState([{ image_path: "", is_primary: 1 }]);
  const mode = "edit";
  const [selectedAddsOns, setSelectedAddsOns] = useState([]);
  const [selectedAddOnsGroup, setSelectedAddOnsGroup] = useState([]);
  const [groupsState, setGroupsState] = useState({});
  const [productData, setProductData] = useState({
    barcode: "",
    name: "",
    description: "",
    status: "active",
    note: "",
    is_vegetarian: 1,
    is_reviewed: 1,
    is_featured: 1,
    is_active: 1,
    store_id: "",
    category_id: "",
    max_cart_quantity: "",
    weight: "",
    preparation_time: "",
    preparation_time_unit: "",
  });

  const [prices, setPrices] = useState({
    price: null,
    purchase_price: null,
    sale_price: null,
  });

  const [productNutrition, setProductNutrition] = useState({
    calories: "",
    fat: "",
    protein: "",
    carbohydrates: "",
    sugar: "",
    fiber: "",
  });

  const [productOptions, setProductOptions] = useState([
    {
      option_id: "",
      min_select: 1,
      max_select: 1,
      is_required: 1,
      sort_order: 1,
      values: [
        {
          name: "",
          price: "",
          stock: "",
          is_in_stock: 1,
        },
      ],
    },
  ]);
  const [availability, setAvailability] = useState([]);
  const [add_ons, setAddsOns] = useState([]);
  const [pharmacyInfo, setPharmacyInfo] = useState([
    { generic_name: "", common_use: "", prescription_required: 1 },
  ]);

  const location = useLocation();
  const page = location.state?.page || 1;
  useEffect(() => {
    if (Object.values(product).length > 0) {
      setProductData((prev) => ({
        ...prev,
        barcode: product?.barcode,
        name: product?.name,
        description: product?.description,
        status: product?.status,
        note: product?.note,
        is_vegetarian: product?.is_vegetarian ? 1 : 0,
        is_reviewed: product?.is_reviewed ? 1 : 0,
        is_featured: product?.is_featured ? 1 : 0,
        is_active: product?.is_active ? 1 : 0,
        store_id: product?.store?.id,
        store_name: product?.store?.name,
        store: product?.store,
        category_id: product?.category.id,
        category_name: product?.category.name,
        max_cart_quantity: product?.max_cart_quantity,
        weight: product?.weight,
        preparation_time: product?.preparation_time,
        preparation_time_unit: product?.preparation_time_unit,
      }));
      setSectionType(product?.store?.store_type);
      setPharmacyInfo(product?.pharmacyInfo);
      setAvailability(product?.availability || []);

      setImages(product.images);
      setPrices((prev) => ({
        ...prev,
        price:
          product?.price !== null && product?.price !== undefined
            ? formatPrice(product.currency_factor, product.price)
            : "",
        sale_price:
          product?.sale_price !== null && product?.sale_price !== undefined
            ? formatPrice(product.currency_factor, product.sale_price)
            : "",
        purchase_price:
          product?.purchase_price !== null &&
          product?.purchase_price !== undefined
            ? formatPrice(product.currency_factor, product.purchase_price)
            : "",
      }));
      setProductNutrition(product.productNutrition);
      setSelectedAddsOns(product.add_on_groups);
      setAddsOns(product.add_on_groups.map((group) => group.id));
      console.log("selectedAddsOns", product.add_on_groups);
      setSelectedAddOnsGroup(product.add_on_groups);
      setProductOptions(
        product.product_options.map((option) => ({
          option_id: option.option.id,
          min_select: option.min_select,
          max_select: option.max_select,
          is_required: option.is_required ? 1 : 0,
          sort_order: option.sort_order,
          values: option.option_values.map((val) => ({
            name: val.product_value.name,
            price: formatPrice(product.currency_factor, val.price),
            stock: val.stock,
            is_in_stock: val.is_in_stock ? 1 : 0,
          })),
        })),
      );
    }
  }, [showData]);

  const { data, isLoading: isCategoriesLoading } = useQuery(
    ["getCategories", productData.store_id, section_id],
    () => getCategories(productData.store_id, section_id),
  );

  const categories = data?.data.categories || [];

  let steps = [
    { id: 1, key: "product", title: "تفاصيل المنتج", icon: 1 },
    { id: 2, key: "availability", title: "إدارة التوفر والمخزون", icon: 2 },
    { id: 3, key: "images", title: "الصور", icon: 3 },
    { id: 4, key: "prices", title: "الأسعار", icon: 4 },
    { id: 5, key: "nutrition", title: "القيم الغذائية", icon: 5 },
    { id: 6, key: "options", title: "الخيارات", icon: 6 },
  ];

  if (section_type === "restaurant") {
    steps = [
      { id: 1, key: "product", title: "تفاصيل المنتج", icon: 1 },
      { id: 2, key: "availability", title: "إدارة التوفر والمخزون", icon: 2 },
      { id: 3, key: "images", title: "الصور", icon: 3 },
      { id: 4, key: "prices", title: "الأسعار", icon: 4 },
      { id: 5, key: "nutrition", title: "القيم الغذائية", icon: 5 },
      { id: 6, key: "addon", title: "الإضافات المطلوبة", icon: 6 },
      { id: 7, key: "options", title: "الخيارات", icon: 7 },
    ];
  }
  if (section_type === "pharmacy") {
    steps = [
      { id: 1, key: "product", title: "تفاصيل المنتج", icon: 1 },
      { id: 2, key: "availability", title: "إدارة التوفر والمخزون", icon: 2 },

      { id: 2, key: "images", title: "الصور", icon: 2 },
      { id: 3, key: "prices", title: "الأسعار", icon: 3 },

      { id: 4, key: "addon", title: "الإضافات", icon: 4 },
      { id: 5, key: "options", title: "تأكيد", icon: 5 },
    ];
  }

  const [activeTab, setActiveTab] = useState("product");
  const currentStep = steps.findIndex((s) => s.key === activeTab) + 1;
  const progress = (currentStep / steps.length) * 100;

  const mutation = useMutation({
    mutationKey: ["postProduct"],
    mutationFn: (postData) => editProduct(postData, id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
    },
    onError: (error) => {
      toast.error(`${error.response.data.message}`);
    },
  });
  console.log("addsOnsPayload", addsOnsPayload);
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    // التعامل مع productData
    Object.keys(productData).forEach((key) => {
      if (
        productData[key] === null ||
        productData[key] === "" ||
        productData[key] === undefined
      ) {
        return;
      }
      formData.append(`product[${key}]`, productData[key]);
    });

    // التعامل مع prices

    Object.keys(prices).forEach((key) => {
      if (prices[key] === null || prices[key] === "") {
        return;
      }
      formData.append(`prices[${key}]`, prices[key]);
    });

    // التعامل مع productNutrition
    if (productNutrition !== null) {
      Object.keys(productNutrition).forEach((key) => {
        formData.append(`productNutrition[${key}]`, productNutrition[key]);
      });
    }

    pharmacyInfo.forEach((key, index) => {
      formData.append(`pharmacyInfo[${index}][generic_name]`, key.generic_name);
      formData.append(`pharmacyInfo[${index}][common_use]`, key.common_use);
      formData.append(
        `pharmacyInfo[${index}][prescription_required]`,
        key.prescription_required,
      );
    });

    // التعامل مع availability
    availability.forEach((item, index) => {
      Object.keys(item).forEach((key) => {
        if (item[key] === null || item[key] === "" || item[key] === undefined) {
          return;
        }
        if (key === "is_in_stock") {
          formData.append(`availability[${index}][${key}]`, item[key] ? 1 : 0);
          return;
        }
        formData.append(`availability[${index}][${key}]`, item[key]);
      });
    });

    formData.append("_method", "PUT");
    formData.append("lang", selectedLangCode);

    images.forEach((img, index) => {
      if (img.file && img.file instanceof File) {
        formData.append(`images[${index}][image_path]`, img.file);
        formData.append(`images[${index}][is_primary]`, img.is_primary ? 1 : 0);
      }
    });
    if (addsOnsPayload?.add_on_groups) {
      addsOnsPayload?.add_on_groups?.forEach((group, groupIndex) => {
        Object.keys(group).forEach((key) => {
          if (
            group[key] === null ||
            group[key] === "" ||
            group[key] === undefined
          ) {
            return;
          }

          // لو مش add_ons
          if (key !== "add_ons") {
            formData.append(`add_on_groups[${groupIndex}][${key}]`, group[key]);
          }
        });

        // add_ons array
        group?.add_ons?.forEach((addon, addonIndex) => {
          Object.keys(addon).forEach((addonKey) => {
            if (
              addon[addonKey] === null ||
              addon[addonKey] === "" ||
              addon[addonKey] === undefined
            ) {
              return;
            }

            formData.append(
              `add_on_groups[${groupIndex}][add_ons][${addonIndex}][${addonKey}]`,
              addon[addonKey],
            );
          });
        });
      });
    }

    productOptions.forEach((option, index) => {
      Object.keys(option).forEach((key) => {
        if (key === "values") {
          // values array داخل option
          option.values.forEach((value, vIndex) => {
            Object.keys(value).forEach((valKey) => {
              formData.append(
                `productOptions[${index}][values][${vIndex}][${valKey}]`,
                value[valKey],
              );
            });
          });
        } else {
          formData.append(`productOptions[${index}][${key}]`, option[key]);
        }
      });
    });
    mutation.mutate(formData);
  };
  const renderTabContent = () => {
    switch (activeTab) {
      case "product":
        return (
          <ProductBasicInfo
            product={product}
            setSectionType={setSectionType}
            mode={mode}
            productData={productData}
            setProductData={setProductData}
            categories={categories}
            availability={availability}
            setAvailability={setAvailability}
            section_type={section_type}
            pharmacyInfo={pharmacyInfo}
            setPharmacyInfo={setPharmacyInfo}
            setErrors={setErrors}
            setSectionId={setSectionId}
            setPrices={setPrices}
            isCategoriesLoading={isCategoriesLoading}
          />
        );
      case "images":
        return (
          <ProductImages
            mode={mode}
            images={images}
            setImages={setImages}
            errors={errors}
            setErrors={setErrors}
          />
        );
      case "availability":
        return (
          <ProductAvailability
            mode={mode}
            availability={availability}
            setAvailability={setAvailability}
            storeId={productData.store_id}
          />
        );

      case "prices":
        return (
          <ProductPrices mode={mode} prices={prices} setPrices={setPrices} />
        );
      case "nutrition":
        return (
          <ProductNutrition
            mode={mode}
            productNutrition={productNutrition}
            setProductNutrition={setProductNutrition}
          />
        );
      case "addon":
        return (
          config.show.addons && (
            <AddsOne
              setSelectedAddOnsGroup={setSelectedAddOnsGroup}
              selectedAddOnsGroup={selectedAddOnsGroup}
              product={product}
              groupsState={groupsState}
              setGroupsState={setGroupsState}
              mode={mode}
              setAddsOnsPayload={setAddsOnsPayload}
              setAddsOns={setAddsOns}
              add_ons={add_ons}
              store_id={productData.store_id}
              setSelectedAddsOns={setSelectedAddsOns}
              selectedAddsOns={selectedAddsOns}
            />
          )
        );
      case "options":
        return (
          config.show.options && (
            <ProductOptions
              mode={mode}
              productOptions={productOptions}
              setProductOptions={setProductOptions}
            />
          )
        );
      default:
        return null;
    }
  };

  console.log(product?.availability);

  return (
    <>
      <HeaderBar
        title={"تعديل المنتج"}
        content={"عدل منتج  مضاف لمتجرك"}
        isBack={true}
        isEdit={true}
        setSelectedLangCode={setSelectedLangCode}
        selectedLangCode={selectedLangCode}
        indexPath={`/products`}
        page={page}
      />
      {isLoading && <LoadingSpinner />}
      <form onSubmit={handleSubmit} className="product-form add">
        <div className="container">
          <div className="card rounded-4">
            <div className="card-body">
              <div className="row mb-2 justify-content-center align-items-center">
                <div
                  className="position-relative mt-3 "
                  style={{ height: "40px" }}
                >
                  {/* Progress bar */}

                  {/* Steps circles */}
                  <div className="d-flex justify-content-between align-items-center position-absolute top-0 start-0 w-100 translate-middle-y">
                    {steps.map((s) => (
                      <OverlayTrigger
                        key={s.id}
                        placement="top"
                        overlay={
                          <Tooltip id={`step-tooltip-${s.id}`}>
                            انتقال للخطوة رقم {s.id}
                          </Tooltip>
                        }
                      >
                        <div
                          onClick={() => setActiveTab(s.key)}
                          className="d-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            width: "40px",
                            height: "40px",
                            zIndex: "10",
                            cursor: "pointer",
                            backgroundColor:
                              currentStep >= s.id ? "#FFCC03" : "#E6E6E6",
                            color: "#fff",
                            fontWeight: "bold",
                          }}
                        >
                          {s.id}
                        </div>
                      </OverlayTrigger>
                    ))}
                    <div
                      className="progress position-absolute  start-0 w-100 "
                      style={{ height: "12px", top: "40%" }}
                    >
                      <div
                        className="progress-bar bg-primary"
                        role="progressbar"
                        style={{ width: `${progress}%` }}
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between  mb-3">
                  {steps.map((s) => (
                    <small
                      key={s.id}
                      className={`${
                        currentStep >= s.id
                          ? "text-success fw-bold"
                          : "text-muted"
                      } font14`}
                    >
                      {s.title}
                    </small>
                  ))}
                </div>
              </div>

              {/* 🧩 محتوى التبويب */}
              {renderTabContent()}

              {/* أزرار التنقل */}
              <div className="mt-4 d-flex justify-content-between">
                <div>
                  {activeTab !== "product" && (
                    <button
                      type="button"
                      className="btn btn-white me-2"
                      onClick={() => {
                        const currentIndex = steps.findIndex(
                          (s) => s.key === activeTab,
                        );
                        setActiveTab(steps[currentIndex - 1].key);
                      }}
                    >
                      السابق
                    </button>
                  )}
                  {activeTab === "options" ? null : (
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        const currentIndex = steps.findIndex(
                          (s) => s.key === activeTab,
                        );
                        setActiveTab(steps[currentIndex + 1].key);
                      }}
                    >
                      التالي
                    </button>
                  )}
                </div>

                <div>
                  {activeTab !== "options" ? null : (
                    <Button
                      isLoading={mutation.isLoading}
                      type={"submit"}
                      className={"btn-primary"}
                      label={"تأكيد تعديل المنتج"}
                      disabled={mutation.isLoading}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default EditProductPage;
